export default __webpack_public_path__ + "static/media/contact.09418206.jpg";